export default "__VITE_ASSET__DG0t4SPx__"